// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__rE6KL","btn":"Pagination_btn__ZpBBw","numb":"Pagination_numb__3E2vD","dots":"Pagination_dots__t1Xij","active":"Pagination_active__-Kjge"};